import { Link } from 'react-router-dom'

export default function getFilteredTiles(tiles, params) {
    const {
        enableStoreCredit,
        storeCreditExclusionList,
        locale,
        userSummary
    } = params
    return tiles.reduce((acc, tile) => {
        const { id, href, to, analyticsName } = tile

        if (!id) return acc

        if (id === 'credits' && !!enableStoreCredit && storeCreditExclusionList.includes(locale.country)) return acc

        if (id === 'rewardsProgram' && userSummary?.loyaltyConsent === 'true' && userSummary?.loyaltySegment) return acc 
        
        return [...acc, {
            id,
            href,
            to,
            analyticsName,
            key: id,
            component: href ? 'a' : to ? Link : 'div',
        }]
    }, [])
}


